module.exports = __webpack_public_path__ + "media/team/team_office-4d687c15.webp";